import { jsx } from "panel";
import { ButtonBarEl } from "common/components/button-bar";
import { SelectEl } from "common/components/select";
export function template() {
  return /* @__PURE__ */ jsx(SelectEl, { attrs: this.helpers.getSelectAttrs(), params: {
    sections: this.params.sections
  }, class: {
    ["filter-".concat(this.attr("name"))]: true
  }, on: {
    change: (ev) => this.helpers.handleFilterChange(ev),
    menuChange: (ev) => this.helpers.handleMenuChange(ev)
  }, "data-sentry-element": "SelectEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("apply-button") ? /* @__PURE__ */ jsx(ButtonBarEl, { sel: ".mp-button-bar-primary", attrs: {
    role: "button",
    tabindex: 0,
    elref: "applyFilterButton",
    slot: "footer"
  }, on: {
    click: () => this.helpers.handleApplyFilterClick()
  } }, this.attr("apply-button")) : null);
}
